import {
  deleteOtherFundQuota,
  editOtherFundQuota,
  getOtherFundQuotaDetail,
  getOtherFundQuotaOrgCode,
  getOtherFundQuotaPageList,
  saveOtherFundQuota,
} from '../services';

export default {
  namespace: 'otherFundsQuota',
  state: {
    economyClassifyTree: [],
    functionSectionTree: [],
  },
  effects: {
    *getOtherFundQuotaPageList({ payload }, { call }) {
      const result = yield call(getOtherFundQuotaPageList, payload);
      return result;
    },
    *deleteOtherFundQuota({ payload }, { call }) {
      const res = yield call(deleteOtherFundQuota, payload);
      return res;
    },
    *getOtherFundQuotaDetail({ payload }, { call }) {
      const res = yield call(getOtherFundQuotaDetail, payload);
      return res;
    },
    *saveOtherFundQuota({ payload }, { call }) {
      const res = yield call(saveOtherFundQuota, payload);
      return res;
    },
    *editOtherFundQuota({ payload }, { call }) {
      const res = yield call(editOtherFundQuota, payload);
      return res;
    },
    *getOtherFundQuotaOrgCode({ payload }, { call }) {
      const res = yield call(getOtherFundQuotaOrgCode, payload);
      return res;
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
